export default function setSearchTitleAction(searchTitle) {
    return {
        type: 'SET_SEARCH_TITLE',
        payload: searchTitle
    }
}